import { Spinner } from 'ui/spinner';
import { useTemplatePreviewContext, useTemplatePreview } from '../hooks';

export const ExperimentTemplatePreview = () => {
  const PreviewContext = useTemplatePreviewContext({ onlyPreviewContext: true });
  const LoadPreview = useTemplatePreview();
  const isLoading = !PreviewContext || !LoadPreview;
  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <PreviewContext>
          <LoadPreview />
        </PreviewContext>
      )}
    </>
  );
};
